import React from "react";
import ReactDOM from "react-dom/client";
import "@ht/components/dist/style.css";
import "@ht/shared/fonts/fonts.css";
import "@ht/shared/fonts/font-awesome.css";
import "@ht/shared/fonts/ionicons.css";
import "@ht/shared/fonts/flag-icon.min.css";
import "./assets/css/tailwind.css";
import { Provider } from 'react-redux';
import { store } from "./app/store";
import App from "./App";


const container = document.getElementById("root");
if (!container) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(
    container
);
root.render(
    <Provider store={store}>
        <React.Fragment>
            <App />
            <div id="headlessui-portal-root">
                <div />
            </div>
        </React.Fragment>
    </Provider>
)
